import React, { useEffect, useMemo, useState } from "react";
import Loader from "../../Layouts/Loader/Loader";
import { useTreeContext } from "../../context/TreeDataContext";
import "./SideBar.css";
import Tree from "./Tree";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import { hasOwn } from "../../commonFunctions/arrayFunc";
import { collapseFolder } from "../../utils/treeData/folderEditorUtils";
import { fuzzyFilterTree } from "../../utils/treeData/fuzzySearch";

const LeftSideBar = ({
  callbackFunction,
  callbackFunctionForFolder,
  handleNewInsert,
  handleDelete,
  handleEdit,
  explorerData,
  setExplorerData,
  type,
  selectedScreen,
  children,
  isLoader,
  importTemp
}) => {
  const { selectedDevice, setSelectedDevice } = useTreeContext();
  const [searchTerm, setSearchTerm] = useState("");

  const handleTypeClick = (newType) => {
    setSelectedDevice(newType); // "mobile" | "tablet" | "desktop"
  };

  useEffect(() => {
    if (selectedScreen && selectedScreen.parentData) {
      if (!selectedScreen.id) return;
      const parentData = selectedScreen.parentData.toLowerCase();
      if (parentData.includes("desktop")) {
        setSelectedDevice("desktop");
      } else if (parentData.includes("tablet")) {
        setSelectedDevice("tablet");
      } else {
        setSelectedDevice("mobile");
      }
    }
  }, [selectedScreen, setSelectedDevice]);

  const isDeviceShow = type === "Screens" || type === "Apps Block";

  const visibleData = useMemo(() => {
    if (!Array.isArray(explorerData)) return explorerData;
    const data = isDeviceShow ? explorerData.find((item) => item.id === selectedDevice)?.items || [] : explorerData;
    return fuzzyFilterTree(data, searchTerm);
  }, [explorerData, isDeviceShow, selectedDevice, searchTerm]);

  return (
    <div className="leftsidebar">
      <div className="sidebar_top_header">
        <div>{type}</div>
        <div className="d_flex align_center gap_2">{children}</div>
      </div>
      <div className="leftsidebar_body" style={{ height: "calc(100vh - 48px)" }}>
        {isDeviceShow && (
          <div className="device_tabs_container">
            <MaterialIcon
              name="phone_iphone"
              className={`device_tabs ${selectedDevice === "mobile" ? "tab_active" : ""}`}
              onClick={() => handleTypeClick("mobile")}
            />
            <MaterialIcon
              name="tablet"
              className={`device_tabs ${selectedDevice === "tablet" ? "tab_active" : ""}`}
              onClick={() => handleTypeClick("tablet")}
            />
            <MaterialIcon
              name="desktop_windows"
              className={`device_tabs ${selectedDevice === "desktop" ? "tab_active" : ""}`}
              onClick={() => handleTypeClick("desktop")}
            />
          </div>
        )}
        <div className="sidebar_fuzzy_search">
          <MaterialIcon name="search" />
          <input
            type="text"
            placeholder={`Search ${type || ""}`.trim()}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && <MaterialIcon name="close" onClick={() => setSearchTerm("")} />}
        </div>
        <div
          className="leftsidebar_folder_container"
          style={{
            height: isDeviceShow ? "calc(100vh - 218px)" : "calc(100vh - 183px)"
          }}
        >
          {isLoader && <Loader width={40} />}
          {!isLoader && explorerData && (
            <Tree
              folderData={visibleData}
              handleNewInsertFunction={handleNewInsert}
              deleteHandlerFunction={handleDelete}
              editHandlerFunction={handleEdit}
              callbackFunction={callbackFunction}
              callbackFunctionForFolder={callbackFunctionForFolder}
              selectedScreen={selectedScreen}
              explorerData={explorerData}
              setExplorerData={setExplorerData}
              importTemp={importTemp}
              type={type}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const FolderCollapse = ({ explorerData, setExplorerData, type }) => {
  const [isFolderCollapse, setIsFolderCollapse] = useState(false);
  const { sidebarCollapse, setSidebarCollapse } = useTreeContext();

  const handleAllFolderCollapse = () => {
    const data = collapseFolder(explorerData, isFolderCollapse);
    setExplorerData(data);
    setIsFolderCollapse(!isFolderCollapse);

    setSidebarCollapse((prevState) => ({
      ...prevState,
      [type]: !isFolderCollapse
    }));
  };

  useEffect(() => {
    if (hasOwn(sidebarCollapse, type)) {
      setIsFolderCollapse(sidebarCollapse[type]);
    } else {
      setIsFolderCollapse(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="folder_collapse_icon sidebar_collapse" onClick={handleAllFolderCollapse}>
      {isFolderCollapse ? <MaterialIcon name="folder" /> : <MaterialIcon name="folder_open" />}
    </div>
  );
};

export { FolderCollapse };

export default LeftSideBar;
